export default __webpack_public_path__ + "static/GT-America-Standard-Bold-2616c51654337b286809ec7eb2faff9c.woff";